import templateUrl from './assign-work-order-employee-modal.component.html';

export const AssignWorkOrderEmployeeModalComponent = {
    controller: AssignWorkOrderEmployeeModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl
};

function AssignWorkOrderEmployeeModalController($q, employeeService) {
    'ngInject';
    const vm = this;
    vm.$onInit = onInit;

    function onInit() {
        vm.workOrders = vm.resolve.workOrders;
        const icdOffices = vm.workOrders.reduce(function (icdOffices, workOrder) {
            const office = icdOffices.filter(function (office) {
                return workOrder.IcdOfficeID === office;
            })[0];
            if (!office) {
                icdOffices.push(workOrder.IcdOfficeID);
            }
            return icdOffices;
        }, []);
        const dataSource = {
            transport: {
                read: function (options) {
                    let employees;
                    if (vm.resolve.employees) {
                        employees = $q.when(vm.resolve.employees);
                    } else {
                        const filters = {};
                        if (options.data.filter && options.data.filter.filters) {
                            if (options.data.filter.filters[0]) {
                                filters.FullName = options.data.filter.filters[0].value;
                            }
                        }
                        // Load the employees from the service.
                        employees = $q.all(icdOffices.map(function (icdOfficeID) {
                            return employeeService.retrieveEmployees({
                                IcdOfficeID: icdOfficeID,
                                PageIndex: options.data.pageIndex,
                                PageSize: options.data.pageSize,
                                FullName: filters.FullName
                            });
                        })).then(function (v) {
                            // Add employees for each office loaded.
                            let allEmployees = [];
                            v.forEach(function (employees) {
                                allEmployees = allEmployees.concat(employees);
                            });
                            allEmployees.forEach(function (employee) {
                                employee.FullName = employee.FirstName + " " + employee.LastName;
                            });
                            return allEmployees;
                        });
                    }
                    employees.then(function (employees) {
                        vm.selectedEmployee = vm.selectedEmployee || employees[0];
                        options.success(employees);
                    }).catch(function (ex) {
                        options.error(ex);
                    });
                }
            },
            serverFiltering: true,
            serverPaging: true,
            pageSize: 30
        };
        vm.employeesListOptions = {
            dataSource: dataSource,
            filter: "contains",
            dataTextField: "FullName",
            dataValueField: "Id"
        }
    }
}
